import script from "./DetailListInvoiceProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailListInvoiceProxy.vue?vue&type=script&setup=true&lang=js"

import "./DetailListInvoiceProxy.vue?vue&type=style&index=0&id=8af58ea2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8af58ea2"]])

export default __exports__